<template>
    <div>
        <input
            class="form-control"
            v-model="text"
            :list="`${id}`"
            @change="selectOption"
            @click.prevent="() => {}"
            :placeholder="placeholder"
        />
        <datalist :id="`${id}`">
            <option v-for="item in list" :key="item.id">{{ item.text }}</option>
        </datalist>
    </div>
</template>
<script>
export default {
    name: "autocomplete",
    props: {
        id: "autocomplete",
        list: {
            type: Array,
            default: () => [
                //{id: null, text: null},
                //...
            ],
        },
        model: {
            type: String,
            default: null,
        },
        placeholder: "",
        allowNewValue: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            text: null,
        };
    },
    methods: {
        selectOption() {
            let selected = this.list.find(
                (item) => item.text.toLowerCase() === this.text.toLowerCase(),
            );
            if (selected) {
                return this.$emit("selected", selected.id);
            } else {
                this.$emit("selected", this.text);
            }
        },
    },
    watch: {
        text() {
            if (this.text) {
                return this.selectOption();
            }
            this.$emit("selected", null);
        },
        model() {
            if (this.model) {
                let selected = this.list.find((item) => item.id === this.model);
                if (selected) {
                    this.text = selected.text;
                }
                return;
            }
            this.selectOption();
        },
    },
};
</script>
